"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotate90Degrees = void 0;
/**
 * Returns a 90 degrees rotated version of the given 2-vector.
 * @param p a 2d vector
 */
function rotate90Degrees(p) {
    return [-p[1], p[0]];
}
exports.rotate90Degrees = rotate90Degrees;
//# sourceMappingURL=rotate-90-degrees.js.map